/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-cycle */
import React from 'react';
import { Box } from '@mui/material';
import { Grid } from '@mui/system';
import { BaseShimmer } from '../index';
import '../shimmer.scss';

function ContactShimmer() {
  return (
    <Box className="contact-shimmer-wrap">
      {/* Hero Section Shimmer */}
      <Box sx={{ padding: '60px 100px', textAlign: 'center' }}>
        <BaseShimmer height="48px" width="50%" style={{ margin: '0 auto 20px' }} />
        <BaseShimmer height="18px" width="70%" style={{ margin: '0 auto' }} />
      </Box>

      {/* Contact Info Section Shimmer */}
      <Box sx={{ padding: '60px 100px', backgroundColor: '#f8f9fa' }}>
        <Grid container spacing={4}>
          {Array.from({ length: 3 }).map((_, index) => (
            <Grid key={index} size={{ xs: 12, md: 4 }}>
              <Box sx={{ textAlign: 'center', padding: '30px' }}>
                <BaseShimmer
                  height="60px"
                  width="60px"
                  variant="circular"
                  style={{ margin: '0 auto 20px' }}
                />
                <BaseShimmer height="24px" width="80%" style={{ margin: '0 auto 12px' }} />
                <BaseShimmer height="16px" width="100%" style={{ margin: '0 auto 6px' }} />
                <BaseShimmer height="16px" width="90%" style={{ margin: '0 auto' }} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Contact Form and Map Section Shimmer */}
      <Box sx={{ padding: '60px 100px' }}>
        <Grid container spacing={6}>
          {/* Contact Form */}
          <Grid size={{ xs: 12, md: 6 }}>
            <BaseShimmer height="32px" width="60%" style={{ marginBottom: '30px' }} />

            {/* Form fields */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <BaseShimmer height="56px" borderRadius="8px" />
              <BaseShimmer height="56px" borderRadius="8px" />
              <BaseShimmer height="56px" borderRadius="8px" />
              <BaseShimmer height="56px" borderRadius="8px" />
              <BaseShimmer height="120px" borderRadius="8px" />
              <BaseShimmer height="48px" width="150px" borderRadius="6px" />
            </Box>
          </Grid>

          {/* Map */}
          <Grid size={{ xs: 12, md: 6 }}>
            <BaseShimmer height="400px" borderRadius="12px" />
          </Grid>
        </Grid>
      </Box>

      {/* Schedule Appointment Section Shimmer */}
      <Box sx={{ padding: '60px 100px', backgroundColor: '#114559' }}>
        <Box sx={{ textAlign: 'center' }}>
          <BaseShimmer
            height="36px"
            width="50%"
            style={{
              margin: '0 auto 20px',
              background: 'linear-gradient(90deg, #2a3a4a 25%, #3a4a5a 50%, #2a3a4a 75%)',
              backgroundSize: '200px 100%',
            }}
          />
          <BaseShimmer
            height="18px"
            width="70%"
            style={{
              margin: '0 auto 30px',
              background: 'linear-gradient(90deg, #2a3a4a 25%, #3a4a5a 50%, #2a3a4a 75%)',
              backgroundSize: '200px 100%',
            }}
          />
          <BaseShimmer
            height="42px"
            width="160px"
            borderRadius="6px"
            style={{
              margin: '0 auto',
              background: 'linear-gradient(90deg, #2a3a4a 25%, #3a4a5a 50%, #2a3a4a 75%)',
              backgroundSize: '200px 100%',
            }}
          />
        </Box>
      </Box>

      {/* Location Gallery Section Shimmer */}
      <Box sx={{ padding: '60px 100px' }}>
        <BaseShimmer height="36px" width="40%" style={{ margin: '0 auto 40px' }} />

        <Grid container spacing={3}>
          {Array.from({ length: 6 }).map((_, index) => (
            <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
              <Box>
                <BaseShimmer height="250px" borderRadius="12px" style={{ marginBottom: '16px' }} />
                <BaseShimmer height="20px" width="80%" style={{ marginBottom: '8px' }} />
                <BaseShimmer height="16px" width="100%" style={{ marginBottom: '4px' }} />
                <BaseShimmer height="16px" width="70%" />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Additional Contact Information */}
      <Box sx={{ padding: '60px 100px', backgroundColor: '#f8f9fa' }}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 6 }}>
            <BaseShimmer height="32px" width="70%" style={{ marginBottom: '20px' }} />
            <BaseShimmer height="18px" width="100%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="95%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="80%" style={{ marginBottom: '20px' }} />

            {/* Contact details */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <BaseShimmer height="24px" width="24px" variant="circular" />
                <BaseShimmer height="16px" width="200px" />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <BaseShimmer height="24px" width="24px" variant="circular" />
                <BaseShimmer height="16px" width="180px" />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <BaseShimmer height="24px" width="24px" variant="circular" />
                <BaseShimmer height="16px" width="220px" />
              </Box>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <BaseShimmer height="32px" width="60%" style={{ marginBottom: '20px' }} />

            {/* Business hours */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {Array.from({ length: 7 }).map((_, index) => (
                <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <BaseShimmer height="16px" width="80px" />
                  <BaseShimmer height="16px" width="120px" />
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default ContactShimmer;
